export default "__VITE_ASSET__BVmTJQ6O__"